import type { IntlKey } from 'locales';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const ImportantNotice: FC = () => {
  return (
    <div className="text-start p-1">
      <FormattedMessage id={`tradeCancellation.content.INIT.importantNotice` as IntlKey} />
      <ul>
        {[...Array(5)].map((_, i) => (
          <li key={i}>
            <FormattedMessage id={`tradeCancellation.content.INIT.importantNotice.${i + 1}` as IntlKey} />
          </li>
        ))}
      </ul>
    </div>
  );
};
